import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import { logoContainer } from './LogoComponent.module.css'

const LogoComponent = ({ extraClassName }) => {
  return (
    <div className={`${logoContainer} ${extraClassName}`}>
      <StaticImage
        alt="Logo"
        formats={['auto', 'webp']}
        loading="eager"
        placeholder="none"
        quality="50"
        src="../../assets/images/logo.webp"
      />
    </div>
  )
}

export default LogoComponent
